<!-- 
Toolbar button for signing in or out.
-->
<template>
  <v-toolbar-items>
    <v-btn 
      v-if="!isSignedIn && !isSigningIn" id="sign-in-toolbar-button" flat small 
      class="pr-3" to="/sign-in"
    >
      <v-icon class="mr-2">person_outline</v-icon>
      Sign in
    </v-btn>

    <v-menu
      v-if="isSignedIn" v-model="menu"
      :close-on-content-click="true"
      offset-y offset-x
    >
      <v-btn slot="activator" flat small>
        <v-icon class="mr-2">person</v-icon>
        <span class="hidden-sm-and-down">{{ user.userName }}</span>
        <our-expand-icon :expanded="menu"/>
      </v-btn>

      <v-card>
        <v-list>
          <v-list-tile avatar @click="navigateToProfile">
            <v-list-tile-avatar>
              <v-icon class="pr-3">verified_user</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ user.userName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn v-if="!onChangePasswordPage" :disabled="busy" flat @click="showChangePasswordDialog=true">Change password</v-btn>
          <v-btn :disabled="busy" to="/sign-out" color="primary" flat>Sign out</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <change-password-dialog v-model="showChangePasswordDialog" />
  </v-toolbar-items>
</template>

<script>
import ChangePasswordDialog from "@/components/users/ChangePasswordDialog.vue";
import filterMixins from "@/mixins/filter.mixins";

export default {
  components: { ChangePasswordDialog },
  mixins: [filterMixins],
  data() {
    return {
      menu: false,
      busy: false,
      showChangePasswordDialog: false
    };
  },
  computed: {
    isSignedIn() {
      return this.$store.getters.isSignedIn;
    },
    isSigningIn() {
      return this.$route.path == "/";
    },
    user() {
      return this.$store.state.users.user.details;
    },
    onChangePasswordPage() {
      
      return this.$route.path.startsWith("/change-password");
    }
  },
  methods: {
    navigateToProfile(){
      const url = `/user/profile`;
      this.$router.push(url);      
    }
  }
};
</script>
